import { createInjectionKey as e } from "./ghl-ui.es896.js";
const i = e("n-time-picker");
export {
  i as timePickerInjectionKey
};
